import LOADS from '~/modules/loads/types';
import RESOURCE from '~/modules/resources/types';
import create from '~/misc/create';
import backhaulIdentity from './backhaulIdentity';

const backhaulResource = (loadIdentity) => ({
  name: 'backhaul',
  need: backhaulIdentity(loadIdentity),
  needy: loadIdentity,
});

export default {
  [RESOURCE.RESOURCE]: [
    (action, {dispatch}) => {
      if (action.meta.name !== 'load') {
        return;
      }

      if (action.error || action.pending) {
        return;
      }

      const backhaul = {
        name: 'backhaul',
        need: backhaulIdentity(action.meta),
        needy: action.meta,
      };

      dispatch(create(RESOURCE.RESOURCE_NEEDED, backhaul));
    },
  ],
  [RESOURCE.RESOURCE_DISPOSED]: [
    (action, {dispatch}) => {
      if (action.payload.name !== 'load') {
        return;
      }

      const backhaul = {
        name: 'backhaul',
        need: backhaulIdentity(action.payload),
        needy: action.payload,
      };

      dispatch(create(RESOURCE.RESOURCE_NOT_NEEDED, backhaul));
    },
  ],
  [LOADS.SEARCH_LOAD_INACTIVE]: [
    (action, {dispatch}) => {
      const {identity: loadIdentity} = action.payload;
      const backhaul = backhaulResource(loadIdentity);

      dispatch(create(RESOURCE.RESOURCE_NOT_NEEDED, backhaul));
    },
  ],
  [LOADS.SEARCH_LOAD_ACTIVE]: [
    (action, {dispatch}) => {
      const {identity: loadIdentity} = action.payload;
      const backhaul = backhaulResource(loadIdentity);

      dispatch(create(RESOURCE.RESOURCE_NEEDED, backhaul));
    },
  ],
};



// WEBPACK FOOTER //
// ./src/modules/backhaul/reactions.js